import { useEffect } from "react";

/**
 * Broadcasts a form-dialog's open/close state so the mobile BottomTabNavigation
 * shows its Save/Cancel FABs. Those FABs click the dialog's hidden
 * `data-action="dialog-save"` / `data-action="dialog-cancel"` buttons.
 *
 * Use in any dialog that wants the shared bottom-bar action buttons on mobile.
 */
export function useBottomBarFormDialog(open: boolean): void {
  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent("event-form-dialog", { detail: { open } })
    );
    return () => {
      if (open) {
        window.dispatchEvent(
          new CustomEvent("event-form-dialog", { detail: { open: false } })
        );
      }
    };
  }, [open]);
}
